import type { Richtext } from 'storyblok-js-client';

export function replacePlaceholdersInRichText(
  text: Richtext,
  placeholdersMap: Record<string, string | number>,
): Richtext {
  const item = { ...text };

  if (item.text) {
    item.text = replacePlaceholdersInText(item.text, placeholdersMap);
  }

  if (item.content) {
    item.content = item.content.map((text) =>
      replacePlaceholdersInRichText(text as Richtext, placeholdersMap),
    );
  }

  return item;
}

/**
 * Replaces placeholders like {{onlyLetters}} with values from the placeholdersMap param.
 * In case placeholdersMap doesn't contain needed variable, placeholder will be removed from the initial text.
 */
export function replacePlaceholdersInText(
  text: string,
  placeholdersMap: Record<string, string | number | Richtext>,
) {
  return text.replace(/{{(\w*)}}/g, (...matches) =>
    placeholdersMap[matches[1]] ? String(placeholdersMap[matches[1]]) : '',
  );
}

export function getPlaceholdersFromText(text: string) {
  const result = new Set<string>();

  text.replace(/{{(\w*)}}/g, (...matches) => {
    result.add(matches[1]);
    return matches[1];
  });

  return result;
}
